<template>
  <div class="queue_result_con">
    <div v-if="isGettingInfo" class="loading_con">
      <van-loading />
    </div>
    <div v-else-if="isEmpty">
      <van-empty description="暂时没有取号信息" />
    </div>
    <template v-else>
      <div class="queue_result_top">
        <div class="queue_result_info">
          <img
            :src="
              isCancel
                ? require('@/assets/images/error-icon.png')
                : require('@/assets/images/success-icon.png')
            "
          />

          {{
            queueInfo.State == 3 && isFromType == 3
              ? "已入场"
              : queueStateObj[queueInfo.State]
          }}
        </div>
        <img
          class="queue_result_image"
          :src="
            isCancel
              ? require('@/assets/images/quene-cancel-bg.png')
              : require('@/assets/images/quene-bg.png')
          "
        />
      </div>
      <div class="queue_result_bottom">
        <img
          class="queue_info_image"
          :style="{ height: isCancel ? '190px' : '280px' }"
          src="@/assets/images/queue-bottom.png"
        />
        <div class="queue_info_con">
          <div
            class="queue_info_top"
            :style="{
              'border-bottom': isCancel ? 'none' : '1px dashed #DEDEDE',
            }"
          >
            <div class="c-m-b-36 c-ft-28" @click="handleToQueueNumberPage">
              {{ vpnName }}
              <img
                class="queue_info_arrow"
                src="@/assets/images/pullRight.png"
              />
            </div>
            <div class="c-ft-45 bold c-black c-m-b-10">
              {{ queueInfo.QueueNumber }}
            </div>
            <div
              class="c-m-b-20 c-ft-24"
              v-if="queueInfo.PersonnelType || queueInfo.ClassName"
            >
              {{
                isFromType == 3 ? queueInfo.PersonnelType : queueInfo.ClassName
              }}
              <!-- {{queueInfo.QueueTable}} ({{queueInfo.QueueTablePerson}}人) -->
            </div>
            <div class="c-lightgrey c-ft-24">
              {{ queueInfo.CreateTime }}
            </div>
          </div>
          <div class="queue_info_bottom c-flex" v-if="!isCancel">
            <div class="c-f-1 fc-center queue_bottom_con queue_left_con">
              <div class="c-m-b-10">
                <span class="wait_number_con">{{
                  queueInfo.WaitCount || "--"
                }}</span>
                {{ isFromType == 1 ? "桌" : "组" }}
              </div>

              <div class="">还需等待</div>
            </div>
            <div class="c-f-1 fc-center queue_bottom_con">
              <div class="c-m-b-10">
                <span class="wait_number_con">{{
                  queueInfo.PredictTime || "--"
                }}</span>
                分钟
              </div>

              <div class="">预计等待时长</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_submit_con" v-if="queueInfo.State == 1">
        <div class="w-320">
          <van-button color="#FF6C62" plain @click="handleCancelQueue" block
            >取消排队</van-button
          >
        </div>

        <!-- <my-button btnTitle="取消排队" widthData="280px" paddingData="20px 32px" borderRadius="8px" bgColor="#fff"
				borderData="1px solid #FF6C62" color="#FF6C62" @handleClickBtnFunc="handleCancelQueue">

			</my-button> -->
      </div>
    </template>
  </div>
</template>

<script>
import {
  getQueueNumberDetail,
  changeQueueNumberStatus,
  bindQueueNumberByPad,
} from "@/api/quenu.js";
export default {
  data() {
    return {
      isFromType: 1,
      isGettingInfo: true,
      isEmpty: true,
      vpnName: "",
      queueInfo: {
        // VpnName: "水裹",
        // QueueNumber: "A02",
        // ClassName: "小桌",
        // QueueTablePerson: "1-3",
        // CreateTime: "2023-05-22 12:23:45",
        // WaitCount: 15,
        // PredictTime: 26,
        // Woman: 1,
        // Man: 1,
        // Child: 2,
      },
      queueStateObj: {
        1: "取号成功",
        2: "已过号",
        3: "已就餐",
        4: "已取消",
      },
      isCancel: false,
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      const vpnInfo = this.$store.state.vpnInfo;
      this.vpnName = vpnInfo.name;
      if (this.$route.query.needBind) {
        //此时从pad端扫码进入，需要先将用户与pad已取号码进行绑定
        this.handleBindPadNumber();
      } else {
        this.handleGetNumberDetail();
      }
    },
  },
  mounted() {
    // 是否来自入场排队
    this.isFromType = this.$route.query.type;
    this.takeNumberId = this.$route.query.takeNumberId;
    this.needBind = this.$route.query.needBind;

    this.isGettingInfo = true;
    if (this.$store.state.vpnId) {
      const vpnInfo = this.$store.state.vpnInfo;
      this.vpnName = vpnInfo.name;
      if (this.needBind) {
        //此时从pad端扫码进入，需要先将用户与pad已取号码进行绑定
        this.handleBindPadNumber();
      } else {
        this.handleGetNumberDetail();
      }
    }
  },
  methods: {
    handleGetNumberDetail() {
      getQueueNumberDetail({
        id: this.takeNumberId,
        type: this.isFromType,
        vpnId: this.$store.state.vpnId,
      })
        .then((res) => {
          this.isGettingInfo = false;
          this.isEmpty = false;
          // this.queueState=res.State
          this.isCancel = res.State == 4 || res.State == 2;
          this.queueInfo = res;
        })
        .catch((err) => {
          this.isGettingInfo = false;
          this.isEmpty = true;
        });
    },
    handleBindPadNumber() {
      console.log("绑定的门店Id");
      console.log(this.$store.state.vpnId);
      bindQueueNumberByPad({
        id: this.takeNumberId,
        vpnId: this.$store.state.vpnId,
      })
        .then((res) => {
          this.handleGetNumberDetail();
        })
        .catch((err) => {
          console.log(err);

          if (err.message.indexOf("您已取号") != -1) {
            setTimeout(() => {
              this.$router.replace({
                name: "QueueNumber",
                query: { type: this.isFromType },
              });
            }, 1500);
          } else {
            this.isGettingInfo = false;
            this.isEmpty = true;
          }
        });
    },
    handleToQueueNumberPage() {
      // this.$router.go(-1);
      this.$router.replace({
        name: "QueueNumber",
        query: { type: this.isFromType },
      });
    },
    handleCancelQueue() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定取消排队吗？",
        })
        .then(() => {
          changeQueueNumberStatus({
            id: this.takeNumberId,
            type: this.isFromType,
            state: 4,
            vpnId: this.$store.state.vpnId,
          }).then((res) => {
            // this.isCancel = true;
            this.handleGetNumberDetail();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.queue_result_con {
  padding: 30px 50px;
  .loading_con {
    margin: 40% auto 0;
    text-align: center;
  }
  .queue_result_top {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    align-items: center;
    color: #fff;

    .queue_result_image {
      position: absolute;
      height: 220px;
      width: 100%;
    }

    .queue_result_info {
      font-size: 44px;
      z-index: 2;

      img {
        width: 70px;
        height: 70px;
        margin-right: 20px;
        vertical-align: -15px;
      }
    }
  }

  .queue_result_bottom {
    position: relative;

    .queue_info_con {
      position: absolute;
      z-index: 2;
      top: 0;
      width: 100%;
    }

    .queue_info_top {
      // border-bottom: 1px dashed #DEDEDE;
      padding: 90px 0 30px;
      margin: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .queue_info_arrow {
        width: 13px;
        height: 20px;
        margin-left: 20px;
      }
    }

    .queue_info_image {
      // height: 550px;
      width: 100%;
    }

    .queue_info_bottom {
      color: #666;
      font-size: 24px;
      .queue_bottom_con {
        padding: 70px 0;
      }
      .queue_left_con {
        position: relative;
        &:after {
          content: "";
          width: 1px;
          height: 140px;
          background: #dedede;
          position: absolute;
          right: 0;
          top: 40px;
        }
      }
      .wait_number_con {
        color: #ff6c62;
        font-size: 34px;
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }

  .bottom_submit_con {
    @include fixed-bottom-box-con;
    padding: 0 0 64px;
    display: flex;
    justify-content: center;
    border-top: none;
    background: unset;
  }
}
</style>
